import {Injectable} from '@angular/core';
import {AbstractDataServiceDtoAdapter} from 'src/app/modules/core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter';
import {SaleInvoiceConfigurationDataService} from './saleInvoiceConfigurationData.service';
import {SaleInvoiceConfigurationConverter} from '../../../api/entity/converter/saleInvoiceConfiguration.converter';
import {SaleInvoiceConfigurationModel} from '../../../api/entity/saleInvoiceConfiguration.model';


@Injectable({providedIn: 'root'})
export class SaleInvoiceConfigurationDataServiceAdapter extends
    AbstractDataServiceDtoAdapter<SaleInvoiceConfigurationModel, SaleInvoiceConfigurationConverter> {
    constructor(dataService: SaleInvoiceConfigurationDataService, converter: SaleInvoiceConfigurationConverter) {
        super(dataService, converter);
    }
    newStoredEntityInstance(): SaleInvoiceConfigurationModel {
        return new SaleInvoiceConfigurationModel();
    }
}
